export default __webpack_public_path__ + "static/media/about1.b2e95ef5.jpg";